<script>
  import { FEATURES } from '../../utils/constants';
</script>

<section class="py-16">
  <div class="container mx-auto px-4 md:px-16 xl:px-24 pt-16">
    <!-- Features Grid -->
    <div class="grid md:grid-cols-3 gap-4">
      {#each FEATURES as feature}
        <div class="flex flex-col gap-2 p-8 group hover:bg-am-blue rounded-xl transition border-am-blue-20 border-2 duration-300 ease-in-out cursor-pointer">
          <div class="flex items-start justify-between mb-6 gap-4">
            <h3 class="text-am-black group-hover:text-am-white text-3xl font-bold">{feature.title}</h3>
          </div>
          <p class="text-am-black-75 group-hover:text-am-white">
            {@html feature.description}
          </p>
        </div>
      {/each}
    </div>
  </div>
</section>